export type IgnoredError = {
  message: string
  companyIds?: string[]
  locationIds?: string[]
}

const querySelectorCompanyIds = [
  'T31zdZGzf4xV3o5yLJ15',
  'J64cqWc8VqL3UtDk7vlu',
  'Tkp15b2birOdQAMRCPZ6',
  'P0DmdOJ6HD0YoKEi4nTC',
]
const currentUrlCompanyIds = ["X1ELmR1qJKo6xEivb3Rx"];

const innerHTMLCompanyIds = [
  'uZu0b54lexl1TGIKWqwg',
  'tOM4pIO6d80ezqlyl4RM',
  'HUdXKfHsMNYEBMtBoGX9',
  '7NxPe3weBN0nqPR4CobV',
  'n8W3eayiFU4JZSLwNAC2',
  'a7I2P213IoXdxazCdzCZ',
  'Y5LkugEIdRTWYl6WIOUg',
  'VkyEJ51GcMomeI7KnJ48',
  'NT8XXMync61bzsIbB0ol',
  'lhQZj4Vw1kh9602dkkaF',
]
const SVGInjectorCompanyIds = [
  'q0h75FVYXJTnbA77vVoG',
  'wek3MwXO045nVZFmifD6',
  'cDUIa2OqnlRExRaHzIde',
  '7NxPe3weBN0nqPR4CobV',
  'tFdl6RCjECqJxdLlHRaW',
  'VLaloeibGT2ksOo7PFbP',
  'NbpQMTIthiNipDfxAMsZ',
  '7tqsoZRXIPsMtk1rDKX1',
  'T2qsqmq77k96rgaVwsYL',
  'Tkp15b2birOdQAMRCPZ6',
  'VvR0dGoLIyYArImsTgEt',
  'decfofPC7OzKEi1myLvP',
  'ZFiiZZIuIgQqoG5lckt1',
  'ktapXmiRvMM4pJHyN3b3',
  'KcRdupWKH29yk8Wou1k3',
  'oRYgUnVau3xvnL4FsxF9',
  'pPHSevft0OP5zNGCsZ4A',
  'Jpdeqhx1GhywYRSIQjB6',
  '5TyDxlrAPHLjug6FXGlA',
  'nNFpM58nLle2hRvlW8A8',
  'LbcQj7eflOl2SvbgOYHx',
]

const twilioIgnores: IgnoredError[] = [
  { message: `Cannot read properties of undefined (reading 'includes')` },
  { message: 'AccessTokenExpired' },
  { message: `InvalidStateError: Attempt to register when device is in state "registered"` },
]
const firebaseIgnores: IgnoredError[] = [{ message: 'FirebaseError' }]
export const ignoredErrorMaps: IgnoredError[] = [
  { message: 'user_not_logged_in' },
  { message: '.remoteConfig.getString' },
  { message: 'ConnectionError' },
  { message: 'UnknownError' },
  { message: 'has already been declared' },
  { message: 'last_message_date' },
  { message: 'ResizeObserver' },
  { message: 'Cannot read properties of' },
  { message: `not an object (evaluating 'this.frame` },
  { message: 'has no properties' },
  { message: 'does not exist in container' },
  { message: 'not an object' },
  { message: 'promise rejection captured' },
  { message: 'Network Error' },
  { message: 'error: #additional-info-tab not found' },
  { message: 'error: #additional-info > div > input not found' },
  { message: 'Request failed with status ' },
  { message: 'ghl_customizer' },
  { message: 'is read-only' },
  { message: 'error: #sb_conversations not found' },
  { message: 'window.webkit' },
  { message: 'HubSpotConversation' },
  { message: 'Applying a mismatched transaction' }, // ignoring prosemirror errors
  { message: `Error: .hl_header .hl_header--controls:last-child not found`, companyIds: ['Y5LkugEIdRTWYl6WIOUg'] },
  { message: `Cannot set properties of`, companyIds: innerHTMLCompanyIds },
  { message: `is not a function`, companyIds: innerHTMLCompanyIds },
  { message: `ReferenceError: currentUrl is not defined`, companyIds: currentUrlCompanyIds },
  { message: 'SVGInjector is not defined', companyIds: SVGInjectorCompanyIds },
  { message: '$ is not defined', companyIds: SVGInjectorCompanyIds },
  { message: 'Error: Rejected' }, // service worker registration fails in android devices with this error
  { message: 'UnhandledRejection: Non-Error promise rejection captured with value: Timed out' }, // error coming from reCaptcha
  { message: 'helpers is not defined', companyIds: ['LbcQj7efI0I2SvbgOYHx'] },
  { message: `Failed to execute`, companyIds: querySelectorCompanyIds },
  { message: `ReferenceError: us is not defined`, companyIds: ['IH8OpCN1mZLvrIRaw5Pw'] },
  { message: `[placeholder='Enter opportunity name'] not found`, companyIds: ['eg5pFF7mXMNGkoyJzpve'] },
  { message: `timeout is not defined`, companyIds: ['pnH088XSTvkL713LxqAW'] },
  { message: `InvalidStateError` },
  { message: `node.querySelector is not a function`, companyIds: ['ohS4WYIrXlvxq71lk1wI'] },
  {
    message: 'end is not a function', // sentry issue
    companyIds: ['dVGpbXN5eZxYjl6StDRD', 'YpHFilstxVxfGieBoJjV', 'eg5pFF7mXMNGkoyJzpve'],
  },
  {
    message: 'Network response was not ok', //custom JS error
    companyIds: ['sXgoks94iAbDkSxh89ZK', 'xDYhK2puxqmKvZVA6hqC', 'syradvmsaLhcIU4sw43d', 'EyxZvYYBPPb6CAm0MSes'],
  },
  { message: `slot[default] should have exactly one child` },
  ...twilioIgnores,
  ...firebaseIgnores,
]
